import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderFilled, EyeInvisibleFilled } from '@ant-design/icons';
import Tooltip from 'components/Tooltip';

const Library = ({ library, eventID, handlePickItem }) => {
	const [overflow, setOverflow] = useState(false);
	const navigate = useNavigate();
	const libraryNameRef = useRef();

	const isEllipsisActive = e => {
		return e.offsetWidth < e.scrollWidth;
	};
	const checkOverflow = () => {
		setOverflow(isEllipsisActive(libraryNameRef.current));
	};
	useEffect(() => {
		checkOverflow();
		window.addEventListener('resize', checkOverflow);
		return () => window.removeEventListener('resize', checkOverflow);
	}, []);

	const handleClick = () => {
		navigate(`/events/${eventID}/materials/library/${library.id}`);
	};

	const libraryButton = (
		<div
			key={`material-library-${library.id}`}
			className={'library'}
			onClick={handlePickItem ? handlePickItem(library) : handleClick}
		>
			<FolderFilled />
			<p ref={libraryNameRef}>{library.name}</p>
			<div className={`library-hidden-icon ${library.hidden ? 'hidden' : ''}`}>
				<EyeInvisibleFilled />
			</div>
		</div>
	);

	return overflow ? (
		<Tooltip content={library.name} placement="top">
			{libraryButton}
		</Tooltip>
	) : (
		libraryButton
	);
};

export default Library;
